import React, { useState } from "react"
import {
  sidebarWrapper,
  sidebarOpen,
  sidebar,
  slideIn,
  close,
  contentWrapper,
  menuList,
  topLevel,
  topLevelActive,
  innerLi,
  active,
  deskenPlus,
  deskenPlusActive,
  deskenList,
  showDesken,
  menuSpacer,
  deskLink,
  searchBoxWrapper,
  quickNavItem,
} from "./sidebar.module.css"
import { FaChevronDown, FaChevronRight, FaPlus, FaTimes } from "react-icons/fa"
import linkBuilder from "../../modules/linkBuilder"
import { Link } from "gatsby"
import SearchBox from "../search-box/search-box"
import { dataLayer, trackEvent } from "../../modules/analytics"

const Sidebar = ({
  isActive,
  toggleMenu,
  data,
  backgroundImage,
  notification,
  desks,
  gradient,
}) => {
  const [deskenActive, toggleDesken] = useState({})

  return (
    <div
      className={`${sidebarWrapper} ${isActive === true ? sidebarOpen : ""}`}
      onClick={() => toggleMenu(!isActive)}
      onKeyPress={(event) => console.log(event)}
      role="button"
      tabIndex="-1"
    >
      <div className={`${sidebar} ${isActive === true ? slideIn : ""}`}>
        {desks && (
          <div className={contentWrapper}>
            <div
              className={searchBoxWrapper}
              onClick={(event) => event.stopPropagation()}
            >
              <SearchBox />
            </div>
            <ul className={menuList}>
              <li>
                <Link
                  className={topLevel}
                  to="/"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_home")}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  className={quickNavItem}
                  to="/kennissessies"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_kennissessies")}
                >
                  Kennissessies
                </Link>
              </li>
              <li>
                <Link
                  className={quickNavItem}
                  to="/producten"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_producten")}
                >
                  Producten
                </Link>
              </li>
              <li>
                <a
                  className={quickNavItem}
                  href="https://www.mkbservicedesk.nl/samenwerken/"
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Partner worden?
                </a>
              </li>
              <li>
                <a
                  className={quickNavItem}
                  href="https://www.mkbservicedesk.nl/samenwerken/mkbselect/"
                  onClick={() => trackEvent("nav_mobilemenu_mkbselect")}
                >
                  MKB Select
                </a>
              </li>
              <li>
                <Link
                  className={quickNavItem}
                  to="/nieuws/mkb-servicedesk/over-mkb-servicedesk"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Over ons
                </Link>
              </li>
              <li className={menuSpacer}></li>
              {desks
                .sort((a, b) => {
                  if (a.name < b.name) return -1
                  if (a.name > b.name) return 1
                  return 0
                })
                .map((desk, index) => {
                  return (
                    <li key={desk.id}>
                      <button
                        className={
                          deskenActive[desk.id] ? topLevelActive : topLevel
                        }
                        onClick={(event) => {
                          if (!deskenActive?.[desk.id])
                            trackEvent("nav_mobilemenu_hero")
                          toggleDesken({
                            ...deskenActive,
                            [desk.id]: !deskenActive?.[desk.id],
                          })
                          event.stopPropagation()
                        }}
                      >
                        {desk.name}{" "}
                        <div
                          className={
                            deskenActive[desk.id]
                              ? deskenPlusActive
                              : deskenPlus
                          }
                        >
                          {!deskenActive[desk.id] && <FaChevronRight />}
                          {deskenActive[desk.id] && (
                            <FaChevronDown color="#ffffff" />
                          )}
                        </div>
                      </button>
                      <ul
                        id="sticky-nav-desk-links"
                        className={`${deskenList} ${deskenActive[desk.id] ? showDesken : ""
                          }`}
                      >
                        {desk?.deskcategory &&
                          desk.deskcategory
                            .sort((a, b) => {
                              if (a.name < b.name) {
                                return -1
                              }
                              if (a.name > b.name) {
                                return 1
                              }
                              return 0
                            })
                            .map((category, index) => {
                              return (
                                <li key={category.id} className={innerLi}>
                                  <Link
                                    to={linkBuilder.deskCategory({
                                      ...category,
                                      desk: desk,
                                    })}
                                    className={deskLink}
                                    activeClassName={active}
                                    onClick={() =>
                                      trackEvent("nav_mobilemenu_hub")
                                    }
                                  >
                                    {category.name}
                                  </Link>
                                </li>
                              )
                            })}
                      </ul>
                    </li>
                  )
                })}
              <li className={menuSpacer}></li>
              {/* <li>
                <Link
                  className={topLevel}
                  to="/nieuws/mkb-servicedesk/over-mkb-servicedesk"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Over Ons
                </Link>
              </li> */}
              {/* <li>
                <Link
                  className={topLevel}
                  to="/nieuws/mkb-servicedesk/contact-mkb-servicedesk"
                  activeClassName={active}
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Contact
                </Link>
              </li> */}
              <li>
                <Link
                  className={topLevel}
                  to="/contact/onderdeel-worden-van-de-mkb-servicedesk-community"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Netwerk
                </Link>
              </li>
              <li>
                <a
                  className={topLevel}
                  href="https://werkenbijvanspaendonck.nl/mkb-servicedesk/"
                  rel="nofollow noreferrer"
                  target="_blank"
                  onClick={() => trackEvent("nav_mobilemenu_link")}
                >
                  Vacatures
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default Sidebar
